import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface JsonViewerDialogData {
  title: string;
  json: any;
}

@Component({
  selector: 'app-json-viewer-dialog',
  templateUrl: './json-viewer-dialog.component.html',
  styleUrls: ['./json-viewer-dialog.component.scss']
})
export class JsonViewerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<JsonViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: JsonViewerDialogData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  onDownload(): void {
    const jsonString = JSON.stringify(this.data.json, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${this.data.title.replace(/\s+/g, '_')}_${new Date().getTime()}.json`;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
